import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface SectionCardProps {
    id?: string
    title?: ReactNode
    description?: ReactNode
    action?: ReactNode
    children: ReactNode
    className?: string
    bodyClassName?: string
}

const SectionCard: FC<SectionCardProps> = ({
    id,
    title,
    description,
    action,
    children,
    className,
    bodyClassName
}): ReactNode => {
    const headingId = useId()

    return (
        <section
            id={id}
            aria-labelledby={title ? headingId : undefined}
            className={cn('flex min-w-0 flex-col rounded-xl border bg-card text-card-foreground shadow-xs', className)}
        >
            {(title || action) && (
                <header className='flex flex-wrap items-start justify-between gap-x-3 gap-y-2 border-b px-4 py-3.5 sm:px-5'>
                    <div className='min-w-0'>
                        {title && (
                            <h2 id={headingId} className='font-heading text-[0.95rem] font-semibold leading-tight'>
                                {title}
                            </h2>
                        )}

                        {description && (
                            <p className='mt-1 text-xs text-muted-foreground'>
                                {description}
                            </p>
                        )}
                    </div>

                    {action && <div className='flex shrink-0 items-center gap-2'>{action}</div>}
                </header>
            )}

            <div className={cn('flex-1 p-4 sm:p-5', bodyClassName)}>
                {children}
            </div>
        </section>
    )
}

export default SectionCard
